import { Box, CircularProgress } from '@mui/material';
import React, { Suspense } from 'react';
import { useGetEnergyGroupsQuery } from '../../../../api/recalcV2/endpoints/energyGroupsApiSlice';

const EnergyXplorerManagementDrawer = React.lazy(() =>
    import('remote/EnergyXplorerManagementDrawer').catch(() => ({
      default: () => <div>Failed to load</div>,
    }))
  );

const EnergyXplorerDrawerContainer = ({ isOpen, onClose, account }) => {

  const { data: energygroups } = useGetEnergyGroupsQuery(account.AccountId)


  return (
    <Suspense fallback={
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', verticalAlign: 'center' }}>
        <CircularProgress />
      </Box>
    }>
          <EnergyXplorerManagementDrawer account={{...account, 
          jsonObjects: 
            [
              ...((energygroups ?? []).map(g => ({object: g, nameKey: 'name', idKey: 'energyGroupId', name: g?.name}))), 
              ]}} open={isOpen} onClose={onClose}  />
      </Suspense>
  );
};

export default EnergyXplorerDrawerContainer;